module.exports = __webpack_public_path__ + "img/kragi-logo2.f623f06a.png";